document.addEventListener('DOMContentLoaded', () => {
  const kitSection = document.querySelector('.section-kit-block')
  if (!kitSection) return;

  kitSection.addEventListener('click', (e) => {
    e.preventDefault()

    if (e.target.matches('select[name="id"]')) {
      const productCardSmall = e.target.closest('product-card-small')
      let variantId = productCardSmall.id

      e.target.addEventListener('change', () => {
        variantId = e.target.value
        productCardSmall.id = variantId
      })
    }

    if (e.target.matches('button[name="add-kit"]')) {
      const productCardSmall = e.target.closest('product-card-small')
      variantId = productCardSmall.id
  
      // Add to cart fetch
      const formData = {
        items: [{
          id: variantId,
          quantity: 1
        }]
      };

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify(formData)
      })
      .then(response => response.json())
      .then(() => {

        if (typeof CartDrawer !== 'undefined') {
          const t = new CartDrawer();
          t.refresh()
        }

        if (document.getElementById('Cart-Drawer')) {
          document.body.classList.add('open-cc');
          document.getElementById('Cart-Drawer').classList.add('active');
          dispatchCustomEvent('cart-drawer:open');
        }
        
      })
      .catch(error => {
        console.error('Error:', error);
      });
    }
  })
}) // End DOMContentLoaded

document.addEventListener('product:variant-changed', (e) => {
  const kitSection = document.querySelector('.section-kit-block')
  if (!kitSection) return;

  // Get Sibling Product Data on Sibling Swatch Change
  const productData = e.detail.productData
  //console.log('xxx productData:', productData)

  const productHandle = productData.handle
  
  // Fetch the Sibling Product's Metafields built out in Template - product.camo-kit.liquid
  fetch(`/products/${productHandle}?view=camo-kit`)
  .then(response => {
    if (!response.ok) {
      throw new Error(`Network response was not ok: ${response.statusText}`);
    }
    return response.text();
  })
  .then(text => {
    const parser = new DOMParser()
    const doc = parser.parseFromString(text, "text/html")
    const mainContent = doc.getElementById('main-content')

    if (mainContent) {
      const metafields = JSON.parse(mainContent.textContent)
      updateKit(metafields, kitSection)
    }
  })
  .catch(error => {
    console.error("Error:", error);
  });

}) // End event

function updateKit(metafields, kitSection) {
  const kitHeading = kitSection.querySelector('.section-header--title')
  if (kitHeading) kitHeading.textContent = metafields.section_heading

  const kitBackgroundImage = kitSection.querySelector('.image-with-text-kit')
  if (kitBackgroundImage) kitBackgroundImage.style = `background-image:url('${metafields.background_image}');background-size:cover;`

  const kitFeaturedImage = kitSection.querySelector('.kit-image img')
  if (kitFeaturedImage) kitFeaturedImage.src = metafields.featured_image

  const kitDescription = kitSection.querySelector('.section-header--description')
  if (kitDescription) kitDescription.textContent = metafields.section_description

  const kitCards = kitSection.querySelectorAll('product-card-small')
  
  kitCards.forEach((kitCard, index) => {
    const productKey = `product_${index + 1}`
    const product = metafields[productKey]
    updateKitCard(kitCard, product)
  })

  function updateKitCard(kitCard, product) {
    const productHandle = product.handle
    fetchProductData(productHandle).then(productData => {
      console.log('xxx productData:', productData)

      // Update Card Heading from MetaObject Product
      const kitCardHeading = kitCard.previousElementSibling.querySelector('.heading')
      if (kitCardHeading) kitCardHeading.textContent = product.title

      const selectedColor = productData.options.find(option => option.name === "Color").values[0] // Each Product has only 1 default color option
      const sizes = productData.options.find(option => option.name === "Size").values
      const defaultVariant = productData.variants.find(variant => variant.option1 === selectedColor && variant.available)
      const defaultVariantId = defaultVariant ? defaultVariant.id : null
      //console.log('xxx defaultVariantId:', defaultVariantId)

      kitCard.setAttribute('data-product-id', productData.id)
      kitCard.setAttribute('data-url', productData.url)
      kitCard.setAttribute('data-product-handle', productData.handle)
      kitCard.setAttribute('data-handle', productData.handle)
      kitCard.setAttribute('data-id', defaultVariantId)
      kitCard.id = defaultVariantId

      const kitCardImageLink = kitCard.querySelector('.product-cart-small--image-link')
      if (kitCardImageLink) {
        kitCardImageLink.href = productData.url
        kitCardImageLink.title = productData.title
      }

      const kitCardImage = kitCard.querySelector('img')
      if (kitCardImage) {
        kitCardImage.src = productData.featured_image
        kitCardImage.setAttribute('data-srcset', productData.featured_image)
        kitCardImage.setAttribute('srcset', productData.featured_image)
        kitCardImage.alt = productData.title
      }

      const kitCardTitle = kitCard.querySelector('.product--title')
      if (kitCardTitle) kitCardTitle.textContent = productData.title

      const kitCardPrice = kitCard.querySelector('.price .amount')
      if (kitCardPrice) kitCardPrice.textContent = formatPrice(productData.price)

      const kitCardDescription = kitCard.querySelector('.short-description')
      if (kitCardDescription) kitCardDescription.textContent = product.description

      // Product Form
      const formWrapper = kitCard.querySelector('.product-card-small--info')
      const oldForm = formWrapper.querySelector('form')
      if (oldForm) {
        const formButton = oldForm.querySelector('button[name="add-kit"]')

        // Create the new form element
        const form = document.createElement('form');

        // Set attributes
        form.method = "post";
        form.action = "/cart/add";
        form.id = `product_form_${productData.id}`;
        form.acceptCharset = "UTF-8";
        form.className = "product-form";
        form.enctype = "multipart/form-data";
        form.setAttribute("data-type", "add-to-cart-form");
        form.noValidate = true;

        // Create inputs
        const formTypeInput = document.createElement('input')
        formTypeInput.name = "form_type"
        formTypeInput.value = "product"
        formTypeInput.type = "hidden"

        const utfInput = document.createElement('input')
        utfInput.name = "utf8"
        utfInput.value = "✓"
        utfInput.type = "hidden"

        const selectedVariantInput = document.createElement('input')
        selectedVariantInput.name = "id"
        selectedVariantInput.id = `selected-variant-id-${productData.id}`
        selectedVariantInput.value = defaultVariantId
        selectedVariantInput.type = "hidden"

        const variantIdInput = document.createElement('input')
        variantIdInput.name = "id"
        variantIdInput.value = defaultVariantId
        variantIdInput.type = "hidden"
        variantIdInput.setAttribute('disabled', true)

        // Lastly remove the old form and replace with new form
        oldForm.remove()
        formWrapper.append(form)
        form.append(formTypeInput, utfInput, selectedVariantInput, variantIdInput)

        // Create the Size Select Input
        if (sizes.length > 1) {

          // Wrapper
          const sizeSelectorWrapper = document.createElement('div')
          sizeSelectorWrapper.className = "variant-selector"
          sizeSelectorWrapper.style = "position: relative; display: inline-block;"

          // Select
          const sizeSelector = document.createElement('select')
          sizeSelector.name = "id"
          sizeSelector.id = `variant-${productData.id}`
          sizeSelector.style = "flex-grow: 1; width: 100%; padding-right: 2rem;"

          // Options
          sizes.forEach(size => {
            const matchingVariant = productData.variants.find(variant => variant.option1 === selectedColor && variant.option2 === size)
            const newOption = document.createElement('option')
            newOption.value = matchingVariant.id
            if (matchingVariant.available) {
              newOption.textContent = size
            } else {
              newOption.textContent = `${size} - Sold out`
              newOption.disabled = true
            }

            sizeSelector.append(newOption)
          })

          // Span
          const svgSpan = document.createElement('span')
          svgSpan.style = "position: absolute; right: 1rem; top: 50%; transform: translateY(-50%); pointer-events: none;"

          // SVG
          const svgHTML = `<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6.99214 10.7602L0.0769043 4.7255L1.38619 3.22412L6.99214 8.1155L12.5981 3.22412L13.9074 4.7255L6.99214 10.7602Z" fill="black"></path></svg>`

          svgSpan.innerHTML = svgHTML
          sizeSelectorWrapper.append(sizeSelector)
          sizeSelectorWrapper.append(svgSpan)
          form.append(sizeSelectorWrapper)

        }
        form.append(formButton)
      }
    })
  }
}

async function fetchProductData(productHandle) {
  return fetch(`/products/${productHandle}.js`)
  .then(response => {
    if (!response.ok) {
      throw new Error(`Network response was not ok: ${response.statusText}`);
    }
    return response.json();
  })
  .catch(error => {
    console.error("Error fetching product data:", error);
    return null; // Return null on error to prevent undefined behavior
  });
}

function formatPrice(price) {
  return `$ ${(price / 100).toFixed(2)}`;
}